import { API, axiosInstance } from "lib";


export const getVehicleDocCountList = (data = {}) => {
    return axiosInstance
        .post(API.VEHICLE_DOC_COUNT, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const getVehicleDocDetialList = (data = {}) => {
    return axiosInstance
        .post(API.VEHICLE_DETAIL_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const getVehicleDocSummaryList = (data = {}) => {
    return axiosInstance
        .post(API.VEHICLE_SUMMARY_LIST, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};

export const getVehicleDocCounts = (data = {}) => {
    return axiosInstance
        .post(API.VEHICLE_DOC_COUNTS, data)
        .then((response) => {
            return response.data;
        })
        .catch((err) => {
            if (err) {
                return err?.response?.data
            }
          ;
        });
};